export const hexRegex = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/
